import { render, staticRenderFns } from "./TellertoTeller.vue?vue&type=template&id=8a6618fe&scoped=true"
import script from "./TellertoTeller.vue?vue&type=script&lang=js"
export * from "./TellertoTeller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6618fe",
  null
  
)

export default component.exports